export enum DocumentTypes {
  file = 'FILE',
}
